import graphql__554565565b3505124d6a from "./__generated__/Footer_platform.graphql.js";
import graphql__16a9b0a793f049b679e9 from "./__generated__/Footer_navigationItems.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import ButtonLink from "../Buttons/ButtonLink";
import Icon from "../Utils/Icon";
import { hasHtmlContent } from "../Utils/htmlStringUtils";
import { useResponsiveFlag } from "../Utils/ResponsiveQueries";

const Footer = props => {
  const platform = useFragment(Footer_platform, props.platform);
  const { footer, logoBackgroundColor, logos } = platform;
  const { subFooterMenu, description } = footer;
  const subFooterNavigationItems = subFooterMenu?.navigationItems;

  const navigationItems = useFragment(Footer_navigationItems, props.navigationItems);

  const { isDesktop } = useResponsiveFlag();

  const footerDescription = hasHtmlContent(description) && description;
  const footerDescriptionClassName = classNames([
    "footer-description",
    { "flex-2": isDesktop && footerDescription }
  ]);
  const footerLogoClassName = classNames([
    "footer-description-logo",
    "float-left",
    { "margin-right-xs": footerDescription }
  ]);

  return (
    <>
      <div className="footer-content-container container padding-md">
        <div className="footer-nav d-flex">
          {navigationItems.map(navigationItem => (
            <div key={navigationItem.id} className="footer-nav-item flex-1">
              {/* Use unclickable elements for submenus & with icons */}
              {navigationItem.isSubMenu && navigationItem.iconClass && (
                <div className="footer-nav-header with-icon">
                  <Icon className={navigationItem.iconClass} />
                  <span className="with-icon-text">{navigationItem.name}</span>
                </div>
              )}

              {/* Use unclickable elements for submenus & without icons */}
              {navigationItem.isSubMenu && !navigationItem.iconClass && (
                <div className="footer-nav-header">
                  <span>{navigationItem.name}</span>
                </div>
              )}

              {/* Actual clickable top level menu items are displayed as links */}
              {!navigationItem.isSubMenu && (
                <ButtonLink
                  href={navigationItem.url}
                  className="footer-nav-header text-primary-inverse btn btn-link btn-sm"
                  iconClassName={navigationItem.iconClass}
                  label={navigationItem.name}
                />
              )}

              <ul className="footer-nav-subnav list-unstyled">
                {navigationItem.children.map(childItem => (
                  <li key={childItem.id}>
                    <ButtonLink
                      href={childItem.url}
                      className="text-primary-inverse"
                      iconClassName={childItem.iconClass}
                      label={childItem.name}
                    />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className={footerDescriptionClassName}>
          <div className={footerLogoClassName}>
            <div
              className="footer-logo-container"
              style={{
                backgroundColor: logoBackgroundColor
              }}
            >
              <img src={logos.footer} className="footer-logo image-contained" alt="" />
            </div>
          </div>

          {footerDescription && (
            <div
              className="footer-description-text"
              dangerouslySetInnerHTML={{ __html: footerDescription }}
            />
          )}
        </div>
      </div>

      {subFooterNavigationItems && (
        <div className="sub-footer bg-black">
          <div className="container text-center">
            <div className="sub-footer-inner-wrapper padding-y-xs text-legend">
              {subFooterNavigationItems.map(navigationItem => (
                <div className="sub-footer-item text-center" key={navigationItem.id}>
                  <ButtonLink
                    href={navigationItem.url}
                    className="text-primary-inverse"
                    iconClassName={null}
                    label={navigationItem.name}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const Footer_platform = graphql__554565565b3505124d6a;

const Footer_navigationItems = graphql__16a9b0a793f049b679e9;

export default Footer;
